module.exports = __webpack_public_path__ + "img/img-aa5cd5e8.721260e4.png";